import { SET_USER } from '../types'

const initialState = {
  selectedSetup: null,
  userSetups: [],
  userPowerSetups: [],
}

const userSetups = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER.SETUP:
      return { ...state, selectedSetup: action.payload }
    case SET_USER.SETUPS:
      return { ...state, userSetups: action.payload }
    case SET_USER.POWER_SETUPS:
      return { ...state, userPowerSetups: action.payload }
    default:
      return state
  }
}

export default userSetups
